import { render, staticRenderFns } from "./IgPost.vue?vue&type=template&id=5138b69e&scoped=true&"
import script from "./IgPost.vue?vue&type=script&lang=js&"
export * from "./IgPost.vue?vue&type=script&lang=js&"
import style0 from "./IgPost.vue?vue&type=style&index=0&id=5138b69e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5138b69e",
  null
  
)

export default component.exports